import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#1f5377',
        secondary: '#c2c9d6',
        anchor: '#052450'
      }
    }
  }
})
